import {
    IManagerDataManager,
    IEmployeeDataManager,
    IPromotionRequestDataManager,
    IConversationDataManager,
    IEventDataManager,
    IJobDataManager,
    IPayHistoryDataManager,
    IConfigurationDataManager,
    ITeamCycleManager,
    IDiagnosticsManager,
    ISalesForceDataManager,
    IAccountDataManager,
    IBudgetServiceManager,
    IUserDataManager,
    INotificationDataManager,
    IPrintServiceDataManager
} from 'typings/dataManagers';

class DataManagerFactory {

    private _managerDataManager: IManagerDataManager;

    private _employeeDataManager: IEmployeeDataManager;

    private _promotionRequestManager: IPromotionRequestDataManager;

    private _conversationDataManager: IConversationDataManager;

    private _eventDataManager: IEventDataManager;

    private _jobDataManager: IJobDataManager;

    private _payHistoryDataManager: IPayHistoryDataManager;

    private _configurationDataManager: IConfigurationDataManager;

    private _teamCycleManager: ITeamCycleManager;

    private _diagnosticsManager: IDiagnosticsManager;

    private _salesForceDataManager: ISalesForceDataManager;

    private _accountDataManager: IAccountDataManager;

    private _budgetServiceManager: IBudgetServiceManager;

    private _userDataManager: IUserDataManager;

    private _notificationDataManager: INotificationDataManager;

    private _printServiceDataManager: IPrintServiceDataManager;

    setPrintServiceDataManager(printServiceDataManager: IPrintServiceDataManager): void {
        this._printServiceDataManager = printServiceDataManager;
    }

    setNotificationDataManager(notificationDataManager: INotificationDataManager): void {
        this._notificationDataManager = notificationDataManager;
    }

    setUserDataManager(userDataManager: IUserDataManager): void {
        this._userDataManager = userDataManager;
    }

    setAccountDataManager(accountDataManager: IAccountDataManager): void {
        this._accountDataManager = accountDataManager;
    }

    setBudgetServiceManager(budgetServiceManager: IBudgetServiceManager): void {
        this._budgetServiceManager = budgetServiceManager;
    }

    setSalesForceDataManager(salesForceDataManager: ISalesForceDataManager): void {
        this._salesForceDataManager = salesForceDataManager;
    }

    setConfigurationDataManager(configurationDataManager: IConfigurationDataManager): void {
        this._configurationDataManager = configurationDataManager;
    }

    setManagerDataManager(managerDataManager: IManagerDataManager): void {
        this._managerDataManager = managerDataManager;
    }

    setEmployeeDataManager(employeeDataManager: IEmployeeDataManager): void {
        this._employeeDataManager = employeeDataManager;
    }

    setPromotionRequestManager(promotionRequestManager: IPromotionRequestDataManager): void {
        this._promotionRequestManager = promotionRequestManager;
    }

    setConversationDataManager(conversationDataManager: IConversationDataManager): void {
        this._conversationDataManager = conversationDataManager;
    }

    setEventDataManager(eventDataManager: IEventDataManager): void {
        this._eventDataManager = eventDataManager;
    }

    setJobDataManager(jobDataManager: IJobDataManager): void {
        this._jobDataManager = jobDataManager;
    }

    setPayHistoryDataManager(payHistoryDataManager: IPayHistoryDataManager): void {
        this._payHistoryDataManager = payHistoryDataManager;
    }

    setTeamCycleManager(teamCycleManager: ITeamCycleManager): void {
        this._teamCycleManager = teamCycleManager;
    }

    setDiagnosticsManager(diagnosticsManager: IDiagnosticsManager): void {
        this._diagnosticsManager = diagnosticsManager;
    }

    getPrintServiceDataManager(): IPrintServiceDataManager {
        return this._printServiceDataManager;
    }

    getNotificationDataManager(): INotificationDataManager {
        return this._notificationDataManager;
    }

    getUserDataManager(): IUserDataManager {
        return this._userDataManager;
    }

    getBudgetServiceMaanger(): IBudgetServiceManager {
        return this._budgetServiceManager;
    }

    getAccountDataMaanger(): IAccountDataManager {
        return this._accountDataManager;
    }

    getSalesForceDataManager(): ISalesForceDataManager {
        return this._salesForceDataManager;
    }

    getConfigurationDataManager(): IConfigurationDataManager {
        return this._configurationDataManager;
    }

    getManagerDataManager(): IManagerDataManager {
        return this._managerDataManager;
    }

    getEmployeeDataManager(): IEmployeeDataManager {
        return this._employeeDataManager;
    }

    getPromotionRequestManager(): IPromotionRequestDataManager {
        return this._promotionRequestManager;
    }

    getConversationDataManager(): IConversationDataManager {
        return this._conversationDataManager;
    }

    getEventDataManager(): IEventDataManager {
        return this._eventDataManager;
    }

    getJobDataManager(): IJobDataManager {
        return this._jobDataManager;
    }

    getPayHistoryDataManager(): IPayHistoryDataManager {
        return this._payHistoryDataManager;
    }

    getTeamCycleManager(): ITeamCycleManager {
        return this._teamCycleManager;
    }

    getDiagnosticsManager(): IDiagnosticsManager {
        return this._diagnosticsManager;
    }
}

export { DataManagerFactory };